"use client";

import { useEffect, useRef, useState } from "react";

export default function TruncatedDescription({ text }: { text: string }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [showReadMore, setShowReadMore] = useState(false);
  const textRef = useRef<HTMLParagraphElement>(null);

  useEffect(() => {
    const checkTruncation = () => {
      if (textRef.current) {
        // scrollHeight is the real height, clientHeight is the 4-line clamped height
        const hasOverflow =
          textRef.current.scrollHeight > textRef.current.clientHeight;
        setShowReadMore(hasOverflow);
      }
    };

    checkTruncation();
    window.addEventListener("resize", checkTruncation);
    return () => window.removeEventListener("resize", checkTruncation);
  }, [text]);

  return (
    <div className="flex flex-col items-start w-full">
      <p
        ref={textRef}
        className={`self-stretch justify-start text-white/50 text-xl font-medium leading-[180%] transition-[opacity,max-height] duration-300 ${
          !isExpanded ? "line-clamp-4 overflow-hidden" : ""
        }`}
        dangerouslySetInnerHTML={{ __html: text ?? "" }}
      />

      {showReadMore && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            setIsExpanded(!isExpanded);
          }}
          className="mt-2 inline-flex items-center justify-center p-1 rounded-md text-[#225bd4] hover:bg-[#225bd4] hover:text-white transition-colors"
          aria-label={isExpanded ? "Read less" : "Read more"}
        >
          {isExpanded ? (
            /* Chevron Up Icon */
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="m18 15-6-6-6 6" />
            </svg>
          ) : (
            /* Chevron Down Icon */
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="m6 9 6 6 6-6" />
            </svg>
          )}
        </button>
      )}
    </div>
  );
}
